import './style.css';
import React, { useEffect, useState } from 'react'
import { http_request } from '../../../../libs/connection';
import { createTimeString } from '../../../../libs/lib';
import { BASE_ROUTE, DEFAULT_ROWS, SESSION_EXPIRED_CODE } from '../../../../config';
import { Button, Collapse } from 'react-bootstrap';
import { BsChevronCompactDown, BsChevronCompactUp } from "react-icons/bs";
import Progress from '../../../../components/progress';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Filter from '../../../../components/filter';

const INIT = 0;
const SEARCH = 1;
const MANUALLY = 2;
var param_status;
var page = 1;

const PurchaseRefundList = () => {
  const [search_params, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [start_date, setStartDate] = useState((function(){ let d = new Date(); d.setMonth(d.getMonth() - 2); return d; })());
  const [end_date, setEndDate] = useState(new Date());
  const [total, setTotal] = useState(0);
  const [list, setList] = useState([]);
  const [search, setSearch] = useState('');
  const [filter_show, showFilter] = useState(false);
  const [is_loading, setLoadingStatus] = useState(false);

  useEffect(()=>{
    param_status = [...(search_params.values())].length ? SEARCH : INIT;
    page = 1;
    loadData();
  }, [pathname]);


  function loadData(){
    if(is_loading) return;
    /*
      查询之前检查状态并决定赋什麽值

      状态分三种：初始(预设参数)、网址设置参数、手动设置参数

      参数优先级分别为：手动参数 > 网址参数 > 预设参数

      页面开始执行时(监听 pathname)，变更状态
      每次手动调整参数后，变更状态

      每次查询后，变更网址参数
    */
    let start_date_value, end_date_value, search_value;
    switch(param_status){
      case INIT:
        start_date_value = createTimeString('y-m-d h:i:s', start_date);
        end_date_value = createTimeString('y-m-d h:i:s', end_date);
      break;
      case SEARCH:
        start_date_value = search_params.get('start_date');
        end_date_value = search_params.get('end_date');
        search_value = search_params.get('search');
        setStartDate(new Date(start_date_value));
        setEndDate(new Date(end_date_value));
        setSearch(search_value);
      break;
      case MANUALLY:
        start_date_value = createTimeString('y-m-d h:i:s', start_date);
        end_date_value = createTimeString('y-m-d h:i:s', end_date);
        search_value = search;
      break;
    }
    
    let params = {
      start: createTimeString('y-m-d ', start_date_value),
      end: createTimeString('y-m-d ', end_date_value),
      page,
      rows: DEFAULT_ROWS
    };
    if(search_value) params.search = search_value;

    setLoadingStatus(true);
    http_request('/purchaseReturnOrder/list', 'POST', params).then(res=>{
      setLoadingStatus(false);
      if(res.success){
        let data = res.data.purchase_return_orders || [];
        if(page === 1){
          setList(data);
        }else{
          setList([...list, ...data]);
        }
        setTotal(res.data.total);
      }else if(res.message === SESSION_EXPIRED_CODE){
        navigate(`${BASE_ROUTE}/logout`);
      }
    });
  }
  function query(){
    param_status = MANUALLY;
    page = 1;
    setSearchParams({
      start_date: createTimeString('y/m/d', start_date),
      end_date: createTimeString('y/m/d', end_date),
      search
    });
    loadData();
  }
  function loadMore(){
    if(page * DEFAULT_ROWS <= total){
      page += 1;
      loadData();
    }
  }

  return (
    <div id="page-purchase-refund-list" className="page">
      <Progress show={is_loading} />
      <div className={`datepicker_pannel bg-white p-3`}>
        <div className='d-lg-none d-flex align-items-center'>
          <span className='fs-6'>採购退货单查询</span>
          <span className='d-flex flex-grow-1 align-items-center justify-content-end' onClick={()=>{ showFilter(!filter_show); }}>
            {
              filter_show ? <BsChevronCompactUp /> : <BsChevronCompactDown />
            }
          </span>
        </div>
        <Collapse in={filter_show}>
          <div>
            <div className='d-block d-lg-none'>
              <Filter 
                search={search}
                start_date={start_date}
                end_date={end_date}
                setSearch={setSearch}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                query={query}
                enableELSearchInput={false}
              />
            </div>
          </div>
        </Collapse>
        <div className='d-none d-lg-block'>
          <Filter 
            search={search}
            start_date={start_date}
            end_date={end_date}
            setSearch={setSearch}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            query={query}
            enableELSearchInput={false}
          />
        </div>
      </div>
      <div className={`container p-2 d-flex flex-column`}>
        {
          (list || []).length === 0 && <div className='flex-grow-1 d-flex align-items-center justify-content-center'>
            <span className='text-secondary'>无资料</span>
          </div>
        }
        <ul className='m-0 p-0'>
          {
            list.map((row, r)=><li key={r} className={`item mb-2 p-3`}>
              <div className="id">{row.mt_list}</div>
              <div className="date">{row.mt_date}</div>
              <div className="no">{row.cu_no}</div>
              <div className="sales">{row.cu_na}</div>
              <div className='d-flex align-items-start justify-content-start'>
                <div className='pt-3 pe-5' onClick={()=>{
                  navigate(`${BASE_ROUTE}/purchase/refund/detail/${row.mt_list}`);
                }}>
                  <Button size="sm" variant='success' className='px-4'>查看</Button>
                </div>
              </div>
            </li>)
          }
        </ul>
        <div className='d-flex align-items-center justify-content-center py-4'>
          {
            (page * DEFAULT_ROWS < total) &&<Button 
              variant='warning' 
              size="sm" 
              className='px-5' 
              onClick={()=>{ loadMore(); }}
            >
              MORE
            </Button>
          }
        </div>
      </div>
    </div>
  )
}


export default PurchaseRefundList